// extracted by mini-css-extract-plugin
export var container = "recipe-simple-header-module--container--a7df2";
export var counter = "recipe-simple-header-module--counter--4d815";
export var counterBox = "recipe-simple-header-module--counter-box--74720";
export var counterLabel = "recipe-simple-header-module--counter-label--85242";
export var link = "recipe-simple-header-module--link--cdb1c";
export var title = "recipe-simple-header-module--title--89303";